import "./IconUserCheck.scss";
import { ReactComponent as PersonCheckIcon } from "./svg/user_check.svg";

type Props = {
  id?: string;
  color?: "gray" | "green" | "orange";
  title?: string;
  "aria-label"?: string;
};

export const IconUserCheck = ({ color = "gray", id = "", title, "aria-label": ariaLabel }: Props) => {
  return (
    <span
      id={id}
      className={`icon-user-check--${color}`}
      role={ariaLabel ? "img" : undefined}
      aria-label={ariaLabel}
      title={title}
    >
      <PersonCheckIcon aria-hidden="true" />
    </span>
  );
};
